import React from "react";

// Responsive sizes, mobile shrinks aggressively so the baked-in "ESG Report
// Builder" text inside the PNG doesn't overflow narrow viewports.
const SIZES = {
  sm: "h-8 sm:h-10 lg:h-12",                    // footer / inline
  md: "h-12 sm:h-14 md:h-16 lg:h-[104px]",      // navbar, phone 48 / tablet 64 / laptop 104
  lg: "h-16 sm:h-20 md:h-24 lg:h-32",           // prominent header
  xl: "h-20 sm:h-28 md:h-32 lg:h-40"            // hero / auth pages
};

export default function Logo({ size = "md" }) {
  const h = SIZES[size] || SIZES.md;
  return (
    <div data-testid="app-logo" className="flex-shrink-0">
      <img src="/logo_esg.png" alt="ESG Report Builder" className={`${h} w-auto max-w-full object-contain`} />
    </div>
  );
}
